
import { lazy, Suspense } from 'react';
import { Routes, Route } from "react-router-dom";
import Layout from "../components/Layout";
import LazyLoad from "../components/LazyLoad";

// Eagerly load frequently accessed pages for immediate rendering
import Index from '../pages/Index';
import Borrowings from '../pages/Borrowings';
import Accounting from '../pages/Accounting';
import ALM from '../pages/ALM';
import InvestmentsPage from '../pages/InvestmentsPage';
import ALMBorrowings from '../pages/ALMBorrowings';
import Compliance from '../pages/Compliance';
import Tasks from '../pages/Tasks';
import Documents from '../pages/Documents';
import DataHub from '../pages/DataHub';
import Settings from '../pages/Settings';
// Eagerly load Compliance pages for immediate rendering
import ComplianceRepository from '../pages/ComplianceRepository';
import ComplianceReports from '../pages/ComplianceReports';
import PredictiveAuditTriggers from '../pages/PredictiveAuditTriggers';
import SecretarialCompliance from '../pages/SecretarialCompliance';

// Global loading fallback that's lightweight
const GlobalLoadingFallback = () => (
  <div className="min-h-[200px] flex items-center justify-center">
    <div className="animate-pulse text-muted-foreground">Loading...</div>
  </div>
);

// Lazy load less frequently accessed pages
const RepaymentDetails = lazy(() => import('../pages/RepaymentDetails'));
const ReportDetail = lazy(() => import('../pages/ReportDetail'));
const Library = lazy(() => import('../pages/Library'));
const Calendar = lazy(() => import('../pages/Calendar'));
const Audit = lazy(() => import('../pages/Audit'));
const NotFound = lazy(() => import('../pages/NotFound'));

export const AppRoutes = () => (
  <Routes>
    {/* Frequently accessed routes - no LazyLoad wrapper for optimal performance */}
    <Route path="/" element={<Layout><Index /></Layout>} />
    <Route path="/borrowings" element={<Layout><Borrowings /></Layout>} />
    <Route path="/accounting" element={<Layout><Accounting /></Layout>} />
    <Route path="/alm" element={<Layout><ALM /></Layout>} />
    <Route path="/alm/investments" element={<Layout><InvestmentsPage /></Layout>} />
    <Route path="/alm/borrowings" element={<Layout><ALMBorrowings /></Layout>} />
    <Route path="/compliance" element={<Layout><Compliance /></Layout>} />
    <Route path="/tasks" element={<Layout><Tasks /></Layout>} />
    <Route path="/documents" element={<Layout><Documents /></Layout>} />
    <Route path="/datahub" element={<Layout><DataHub /></Layout>} />
    <Route path="/settings" element={<Layout><Settings /></Layout>} />
    <Route path="/compliance/repository" element={<Layout><ComplianceRepository /></Layout>} />
    <Route path="/compliance/reports" element={<Layout><ComplianceReports /></Layout>} />
    <Route path="/compliance/audit-triggers" element={<Layout><PredictiveAuditTriggers /></Layout>} />
    <Route path="/compliance/secretarial" element={<Layout><SecretarialCompliance /></Layout>} />
    
    {/* Less frequently accessed routes with simpler Suspense fallback for quicker transitions */}
    <Route path="/borrowings/repayments/:id" element={<Layout><Suspense fallback={<GlobalLoadingFallback />}><RepaymentDetails /></Suspense></Layout>} />
    <Route path="/compliance/reports/:id" element={<Layout><Suspense fallback={<GlobalLoadingFallback />}><ReportDetail /></Suspense></Layout>} />
    <Route path="/library" element={<Layout><Suspense fallback={<GlobalLoadingFallback />}><Library /></Suspense></Layout>} />
    <Route path="/calendar" element={<Layout><Suspense fallback={<GlobalLoadingFallback />}><Calendar /></Suspense></Layout>} />
    <Route path="/audit" element={<Layout><Suspense fallback={<GlobalLoadingFallback />}><Audit /></Suspense></Layout>} />
    <Route path="*" element={<Layout><Suspense fallback={<GlobalLoadingFallback />}><NotFound /></Suspense></Layout>} />
  </Routes>
);
